<template>
 <page>
  
  

  <head-nav :title="person_to.name" :key="person_to.name">
    <icon-button-back slot="left"></icon-button-back>
    <icon-button-home slot="right"></icon-button-home>
  </head-nav>

  <scroll-page ref="scroll-page" :pull-reload="false">
    
    <list-chat :person_id="person_id" :person_to="person_to" :key="person_to.id"/>

   </scroll-page>

   <div class="footer-input">
        <ui-textarea ref="chatinput" class="text-area" :autoSize="true" :val="send_message" @input="(v)=>{send_message = v}" :title="$t('language.chat')" :key="updateKey"/>
        <ui-icon transform="rotateZ(0deg)" :backgroundColor="computeSendColor" @click.native="sendMessage()" class="send-button" icon="drum"></ui-icon>
    </div>
   <audio ref="drumRollSound">
     <source :src="drumRoll" type="audio/mpeg">
    </audio>
  </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import ListChat from '../components/chat/ListChat';
import ScrollPage from '../components/ScrollPage.vue';
import IconButtonBack from '../components/buttons/IconButtonBack';
import UiTextarea from '../components/UiTextarea.vue';
import UiIcon from '../components/UiIcon.vue';
import { eventBus } from '../services/EventBus.js';
import { helper } from '../services/Helper.js';

export default {
  name: 'chat-page',
  data:function(){
    return {
      send_message:"",
      person_id:this.$route.params.person_id,
      updateKey:0,
      sending:false,
      person_to:{name:"--"}, // person you are chatting with
      drumRoll:require('../assets/drumRoll.mp3'),
      drumCount:0,
    }
  },
  computed:{
     ...mapState(['group','appSettings','chatpersons']),
    computePersonToName(){
      return this.person_to ? this.person_to.name : "--";
    },
    computeSendColor(){
      if(this.sending){
        return '#BBBBBB';
      }
      return '#50c0db';
    }
  },
  components: {
    ListChat,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    Page,
    ScrollPage,
    UiTextarea,
    UiIcon,
  },
  methods:{
    playDrum(){
      if(!this.drumRollSound.ended){
          // seek to beginning and restart
          this.drumRollSound.currentTime=0;
        }
        this.drumRollSound.play();
        this.drumCount++;

        if(this.drumCount==10){
          // launch in app review inapp in-app review here
          
        }
    },
    sendMessage(){

      // check message to send
      var messageVoid=helper.stringHasOnlyWhitespace(this.send_message)
      
      if(messageVoid || this.sending){
        this.playDrum();
        return;
      }

      this.drumCount=0;
      this.sending=true;
      
      var options={
        store_key:"id_"+this.person_id,
        to_id:this.person_id,
        user_type:this.person_to.user_type,
        message:this.send_message,
        title:this.$t('language.pushnote_chat_created'),
        url:"/chat/"+this.appSettings.userid, // url to redirect pushnote to
        type:"chat", // user defined type like "news or "chat" or "album" for pushnote purposes
        chat_email:this.person_to.email, // email to send pushnote to
        datetime:new Date().toLocaleString(),
      }

      //console.dir(options);

      this.$store.dispatch('add_chat_message',options).then(()=>{
        this.sending=false;
        
        // clear chat message
        this.$emit('CHAT_MESSAGE_ADDED');
        // scroll scrollpage to bottom
        this.$nextTick(()=>{
          eventBus.$emit("SCROLL_TO_BOTTOM");
        })
        this.send_message="";
        this.updateKey++;
        
       })


    },
  },// methods{}
  created(){
    
  },
  mounted(){

  this.drumRollSound= this.$refs['drumRollSound'];
  
  this.$store.dispatch('get_chat_persons',{}).then((result)=>{

      var chatPersons=result.data;

      
      this.person_to = chatPersons.find(person => person.id === this.person_id);

    })

 
  },

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer-input{
  display:flex;
  align-items: flex-end;
  margin:8px;
}
.send-button{
  position:relative;
  cursor:pointer;
  padding-left:8px;
  font-size:1.4em;
  display:flex;
  align-items:center;
}

.text-area{
  height:38px;
  flex:1;
  margin-bottom:0px;
}
</style>
